<xpo-icon style="height:25px" *ngIf="iconName" [iconName]="iconName"></xpo-icon>
